<template>
  <Card
    v-if="resortSponsorship"
    :has-body-padding-small="true"
  >
    <template #header>
      <h2 class="section-title heading-color">
        Sponsored
      </h2>
    </template>
    <template #body>
      <p class="tw-py-2">
        {{ resortSponsorship.text }}
      </p>
      <a
        class="tw-font-medium link-color-brand"
        :href="resortSponsorship.click_url"
        rel="noopener noreferrer"
        target="_blank"
      >
        Learn More
      </a>
    </template>
  </Card>
</template>

<script>
export default {
  name: 'ResortSponsorshipCard',

  props: {
    resortSponsorship: {
      type: Object,
      default: null,
    },
  },
};
</script>
